module.exports = __webpack_public_path__ + "img/symbol_14.69bf2fa2.png";